import React from 'react';
import {
	Card, Row, Col, Input, Button, Table, Modal, Form, DatePicker,
	message, Tag, Tooltip, Typography, Pagination, Divider,
} from 'antd';
import {
	SearchOutlined, CloseSquareOutlined, ExclamationCircleOutlined,
	RedoOutlined, FileOutlined, HistoryOutlined, SendOutlined,
	EyeOutlined, FileExcelOutlined, CloseCircleOutlined,
	CheckCircleOutlined, ClockCircleOutlined, WarningOutlined,
	IdcardOutlined, CarOutlined, DollarOutlined, CalendarOutlined,
	FileSearchOutlined, NumberOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { connect } from 'react-redux';
import {
	initHandler, ajaxViewHandler, ajaxHandler, setConfig, ajaxDownloadHandler,
} from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;
const { RangePicker } = DatePicker;

const configClass = {
	title: 'Data Jasa Raharja',
	apiUrl: { data: 'transaksi/api/jasa/raharja/' },
};

const config = new Config();

const STATUS_CFG = {
	1: { label: 'Pending',  bg: '#fffbe6', border: '#ffe58f', color: '#ad6800', icon: <ClockCircleOutlined /> },
	2: { label: 'Terkirim', bg: '#f6ffed', border: '#b7eb8f', color: '#389e0d', icon: <CheckCircleOutlined /> },
	3: { label: 'Gagal',    bg: '#fff1f0', border: '#ffa39e', color: '#cf1322', icon: <WarningOutlined /> },
};

const StatusTag = ({ value }) => {
	const s = STATUS_CFG[value] || { label: String(value), bg: '#f5f5f5', border: '#d9d9d9', color: '#666', icon: null };
	return (
		<Tag icon={s.icon} style={{
			borderRadius: 20, fontWeight: 700, fontSize: 12,
			background: s.bg, borderColor: s.border, color: s.color,
			padding: '2px 10px', display: 'inline-flex', alignItems: 'center', gap: 4,
		}}>
			{s.label}
		</Tag>
	);
};

const formatRp = (val) => {
	if (val === undefined || val === null) return '—';
	const n = typeof val === 'number' ? val : Number(val);
	if (isNaN(n)) return String(val);
	return 'Rp ' + n.toLocaleString('id-ID');
};

class DataJasaraharja extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errMsg      : '',
			errTitle    : '',
			loadingData : false,
			loadingExport: false,
			pagination  : { current: 1, pageSize: 25, total: 0 },
			dataSource  : [],
			searchText  : '',
			filterTanggal: null,
			isMobile    : window.innerWidth <= 768,
			visibleModal: false,
			dataModal   : null,
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	_buildParams(page = 1) {
		const { pagination, searchText, filterTanggal } = this.state;
		const limit = pagination.pageSize;
		const offset = (page - 1) * limit;
		let q = `?limit=${limit}&offset=${offset}`;
		if (searchText) q += `&search=${encodeURIComponent(searchText)}`;
		if (filterTanggal && filterTanggal[0]) q += `&tanggal_mulai=${filterTanggal[0].format('DD-MM-YYYY')}`;
		if (filterTanggal && filterTanggal[1]) q += `&tanggal_akhir=${filterTanggal[1].format('DD-MM-YYYY')}`;
		return q;
	}

	async getData(page = 1) {
		this.setState({ loadingData: true });
		const params = this._buildParams(page);
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + params)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState(prev => ({
						dataSource: data.results || [],
						pagination: { ...prev.pagination, current: page, total: data.count || 0 },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	async doRequest(id, code) {
		message.loading({ content: `Memproses ${code}...`, key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + id + '/' + code)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: `${code} berhasil`, duration: 2, key: 'toast' });
					this.getData(this.state.pagination.current);
				} else {
					message.error({ content: `Gagal ${code}`, duration: 2, key: 'toast' });
					this.setState({ errTitle: `Gagal ${code}`, errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: `${code} gagal, coba lagi`, duration: 2, key: 'toast' }));
	}

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Konfirmasi Hapus',
			icon: <ExclamationCircleOutlined />,
			content: 'Data jasa raharja ini akan dihapus. Lanjutkan?',
			okText: 'Hapus', okType: 'danger', cancelText: 'Batal',
			onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Menghapus...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Data berhasil dihapus', duration: 2, key: 'toast' });
					this.getData(this.state.pagination.current);
				} else {
					message.error({ content: 'Gagal menghapus data', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal menghapus data', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: 'Kesalahan pengiriman data', duration: 2, key: 'toast' }));
	}

	showDetail = (judul, dataModal, is_flat = false) => {
		if (!is_flat) {
			this.setState({
				visibleModal: true,
				dataModal: { is_flat, judul, konten: dataModal.Params ? dataModal.Params[0] : dataModal },
			});
		} else {
			this.setState({
				visibleModal: true,
				dataModal: { is_flat, judul, konten: { kolom: judul, value: JSON.stringify(dataModal, null, 2) } },
			});
		}
	};

	async postDataWithDownload() {
		const params = this._buildParams(1).replace(/limit=\d+&offset=\d+&?/, '');
		this.setState({ loadingExport: true });
		message.loading({ content: 'Mengunduh file...', duration: 0, key: 'toast' });
		this.props.ajaxDownloadHandler('get', configClass.apiUrl.data + '?' + params.replace('?', '') + '&export=true')
			.then(() => {
				this.setState({ loadingExport: false });
				if (this.props.isSuccess) {
					const url = window.URL.createObjectURL(new Blob([this.props.responseMsg]));
					const link = document.createElement('a');
					link.href = url;
					link.download = 'sam_jsr_' + moment().format('DD-MM-YYYY_HH-mm-ss') + '.bin';
					document.body.appendChild(link);
					link.click();
					link.remove();
					message.success({ content: 'File berhasil diunduh', duration: 2, key: 'toast' });
				} else {
					message.error({ content: 'Gagal mengunduh file', duration: 2, key: 'toast' });
				}
			})
			.catch(() => { this.setState({ loadingExport: false }); message.error({ content: 'Gagal mengunduh, coba lagi', duration: 2, key: 'toast' }); });
	}

	handleFilter = () => this.getData(1);

	handleReset = () => {
		this.setState({ searchText: '', filterTanggal: null }, () => this.getData(1));
		if (this.formRef.current) this.formRef.current.resetFields();
	};

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => this.getData(1), 400);
	};

	_buildColumns() {
		return [
			{
				title: 'Status', dataIndex: 'status', key: 'status', width: 120, fixed: 'left', align: 'center',
				render: (v) => <StatusTag value={v} />,
			},
			{
				title: 'Nomor', dataIndex: 'nomor', key: 'nomor', width: 155,
				render: (v) => <Text style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 12 }}>{v || '—'}</Text>,
			},
			{
				title: 'Nomor Polisi', dataIndex: 'nomor_polisi', key: 'nomor_polisi', width: 130,
				render: (v) => v ? (
					<Tag style={{ borderRadius: 4, fontWeight: 700, fontSize: 12, fontFamily: 'monospace', background: '#0f2847', color: '#fff', borderColor: '#0f2847', letterSpacing: 1 }}>{v}</Tag>
				) : <Text type="secondary">—</Text>,
			},
			{
				title: 'Nama Pemilik', dataIndex: 'nama_pemilik', key: 'nama_pemilik',
				render: (v) => <Text style={{ fontWeight: 600, fontSize: 13 }}>{v || '—'}</Text>,
			},
			{
				title: 'Pokok SWDKLLJ', dataIndex: 'pokok_swdkllj', key: 'pokok_swdkllj', width: 155, align: 'right',
				render: (v) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: '#1e4d8a', fontWeight: 600 }}>{formatRp(v)}</Text>,
			},
			{
				title: 'Pokok SAMSAT', dataIndex: 'pokok_samsat', key: 'pokok_samsat', width: 145, align: 'right',
				render: (v) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: '#1e4d8a', fontWeight: 600 }}>{formatRp(v)}</Text>,
			},
			{
				title: 'Denda SWDKLLJ', dataIndex: 'denda_swdkllj', key: 'denda_swdkllj', width: 155, align: 'right',
				render: (v) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: v > 0 ? '#cf1322' : '#595959', fontWeight: 600 }}>{formatRp(v)}</Text>,
			},
			{
				title: 'Denda SAMSAT', dataIndex: 'denda_samsat', key: 'denda_samsat', width: 145, align: 'right',
				render: (v) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: v > 0 ? '#cf1322' : '#595959', fontWeight: 600 }}>{formatRp(v)}</Text>,
			},
			{
				title: 'Waktu', dataIndex: 'created_at', key: 'created_at', width: 155,
				render: (v) => v ? (
					<Text style={{ fontSize: 12, color: '#555' }}>{moment(v).format('DD-MM-YYYY HH:mm:ss')}</Text>
				) : <Text type="secondary">—</Text>,
			},
			{
				title: 'Aksi', key: 'aksi', width: 130, fixed: 'right', align: 'center',
				render: (_, row) => (
					<div style={{ display: 'flex', gap: 5, justifyContent: 'center' }}>
						{row.data !== undefined && (
							<Tooltip title="Lihat Data">
								<Button size="small" shape="circle"
									style={{ background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a' }}
									onClick={() => this.showDetail('DATA', row.data)}>
									<FileOutlined />
								</Button>
							</Tooltip>
						)}
						{row.log !== undefined && (
							<Tooltip title="Lihat Log">
								<Button size="small" shape="circle"
									style={{ background: '#fff7e6', borderColor: '#ffd591', color: '#d46b08' }}
									onClick={() => this.showDetail('LOG', row.log, true)}>
									<HistoryOutlined />
								</Button>
							</Tooltip>
						)}
						{row.is_deleted === true && (
							<Tooltip title="Kirim Ulang">
								<Button size="small" shape="circle"
									style={{ background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }}
									onClick={() => this.doRequest(row.id, 'resend')}>
									<SendOutlined />
								</Button>
							</Tooltip>
						)}
						<Tooltip title="Monitor">
							<Button size="small" shape="circle" type="primary" ghost
								onClick={() => this.doRequest(row.id, 'monitor')}>
								<EyeOutlined />
							</Button>
						</Tooltip>
						<Tooltip title="Hapus">
							<Button size="small" shape="circle" danger
								onClick={() => this.showDeleteConfirm(row.id)}>
								<CloseSquareOutlined />
							</Button>
						</Tooltip>
					</div>
				),
			},
		];
	}

	renderDetailModal() {
		const { visibleModal, dataModal, isMobile } = this.state;
		if (!dataModal) return null;

		const isData = !dataModal.is_flat;
		const isLog  = dataModal.is_flat;
		const icon   = isData ? <FileSearchOutlined /> : <HistoryOutlined />;
		const titleLabel = isData ? 'Detail Data Pengiriman' : 'Log Pengiriman';
		const accentColor = isData ? '#1e4d8a' : '#d46b08';
		const accentBg    = isData
			? 'linear-gradient(135deg, #0f2847 0%, #1e4d8a 60%, #0a3d6b 100%)'
			: 'linear-gradient(135deg, #7c3d00 0%, #d46b08 60%, #a05000 100%)';

		const entries = isData
			? Object.entries(dataModal.konten).filter(([, v]) => typeof v !== 'object' || v === null)
			: null;

		const header = (
			<div style={{
				background: accentBg,
				borderRadius: isMobile ? 0 : '10px 10px 0 0',
				padding: isMobile ? '16px 18px' : '22px 28px',
				display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14,
			}}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
					<div style={{
						width: isMobile ? 38 : 48, height: isMobile ? 38 : 48, flexShrink: 0,
						borderRadius: 12, background: 'rgba(255,255,255,0.18)',
						display: 'flex', alignItems: 'center', justifyContent: 'center',
					}}>
						{React.cloneElement(icon, { style: { color: '#fff', fontSize: isMobile ? 18 : 22 } })}
					</div>
					<div>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 14 : 16 }}>{titleLabel}</div>
						{!isMobile && (
							<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginTop: 2 }}>
								{isData ? 'Detail data yang dikirimkan ke sistem Jasa Raharja' : 'Log pengiriman raw data'}
							</div>
						)}
					</div>
				</div>
				<Button type="text" icon={<CloseCircleOutlined style={{ fontSize: 18 }} />}
					onClick={() => this.setState({ visibleModal: false })}
					style={{ color: 'rgba(255,255,255,0.8)', padding: 4 }} />
			</div>
		);

		const content = (
			<div style={{ maxHeight: isMobile ? '55vh' : '60vh', overflowY: 'auto', padding: isMobile ? '14px 16px' : '20px 28px' }}>
				{isData && entries && (
					<div>
						{entries.map(([key, value], i) => (
							<div key={key} style={{
								display: 'flex', gap: 12, padding: '9px 12px',
								background: i % 2 === 0 ? '#f9fbff' : '#fff',
								borderRadius: 8, marginBottom: 4,
								border: '1px solid #edf2f9',
								flexDirection: isMobile ? 'column' : 'row',
							}}>
								<div style={{
									flexShrink: 0,
									width: isMobile ? '100%' : 200,
									fontSize: 12,
									fontWeight: 600,
									color: accentColor,
									paddingRight: 8,
									borderRight: isMobile ? 'none' : '2px solid #d0dff5',
									marginRight: isMobile ? 0 : 4,
									paddingBottom: isMobile ? 2 : 0,
									borderBottom: isMobile ? '1px dashed #e0e8f5' : 'none',
									fontFamily: 'monospace',
									letterSpacing: 0.3,
								}}>
									{key}
								</div>
								<div style={{
									flex: 1,
									fontSize: 13,
									color: '#222',
									fontWeight: 500,
									wordBreak: 'break-all',
								}}>
									{value !== null && value !== undefined ? String(value) : <Text type="secondary">—</Text>}
								</div>
							</div>
						))}
						{entries.length === 0 && (
							<div style={{ textAlign: 'center', padding: 40, color: '#aaa', fontSize: 13 }}>Tidak ada data</div>
						)}
					</div>
				)}

				{isLog && (
					<div>
						<div style={{
							background: '#0f2847', color: '#7dd3fc', padding: isMobile ? 14 : 20,
							borderRadius: 10, fontFamily: 'monospace', fontSize: isMobile ? 11 : 12,
							whiteSpace: 'pre-wrap', wordBreak: 'break-all', lineHeight: 1.7,
							border: '1px solid #1e4d8a',
							boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.3)',
						}}>
							{dataModal.konten.value || '—'}
						</div>
					</div>
				)}
			</div>
		);

		const footer = (
			<div>
				<Divider style={{ margin: '0' }} />
				<div style={{
					padding: isMobile ? '12px 16px' : '14px 28px',
					display: 'flex', justifyContent: 'flex-end',
					background: '#fafafa',
					borderRadius: isMobile ? 0 : '0 0 10px 10px',
				}}>
					<Button icon={<CloseCircleOutlined />} onClick={() => this.setState({ visibleModal: false })}
						style={{ borderRadius: 8, height: 38, minWidth: 100 }}>
						Tutup
					</Button>
				</div>
			</div>
		);

		return (
			<Modal
				visible={visibleModal}
				onCancel={() => this.setState({ visibleModal: false })}
				footer={null}
				title={null}
				closable={false}
				width={isMobile ? 'calc(100vw - 16px)' : 680}
				style={isMobile ? { top: 12, margin: '0 8px' } : { top: 40 }}
				bodyStyle={{ padding: 0 }}
				maskClosable
				destroyOnClose
			>
				{header}
				{content}
				{footer}
			</Modal>
		);
	}

	renderMobileCard(row) {
		const s = STATUS_CFG[row.status] || { label: String(row.status), bg: '#f5f5f5', border: '#d9d9d9', color: '#666', icon: null };
		return (
			<Card key={row.id} style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
				<div style={{ background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)', borderBottom: '1px solid #d0dff5', padding: '12px 14px', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
					<div style={{ width: 42, height: 42, borderRadius: 10, flexShrink: 0, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<IdcardOutlined style={{ color: '#fff', fontSize: 18 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 14, color: '#0f2847', fontFamily: 'monospace' }}>{row.nomor || '—'}</div>
						<div style={{ display: 'flex', gap: 6, marginTop: 5, flexWrap: 'wrap', alignItems: 'center' }}>
							{row.nomor_polisi && (
								<Tag style={{ borderRadius: 4, fontWeight: 700, fontSize: 11, fontFamily: 'monospace', background: '#0f2847', color: '#fff', borderColor: '#0f2847', letterSpacing: 1, margin: 0 }}>{row.nomor_polisi}</Tag>
							)}
							<Tag icon={s.icon} style={{ borderRadius: 20, fontWeight: 700, fontSize: 11, background: s.bg, borderColor: s.border, color: s.color, margin: 0, display: 'inline-flex', alignItems: 'center', gap: 3 }}>{s.label}</Tag>
						</div>
					</div>
					<div style={{ display: 'flex', flexDirection: 'column', gap: 5, alignItems: 'flex-end' }}>
						{row.data !== undefined && (
							<Tooltip title="Lihat Data">
								<Button size="small" shape="circle" style={{ background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a' }} onClick={() => this.showDetail('DATA', row.data)}><FileOutlined /></Button>
							</Tooltip>
						)}
						{row.log !== undefined && (
							<Tooltip title="Lihat Log">
								<Button size="small" shape="circle" style={{ background: '#fff7e6', borderColor: '#ffd591', color: '#d46b08' }} onClick={() => this.showDetail('LOG', row.log, true)}><HistoryOutlined /></Button>
							</Tooltip>
						)}
					</div>
				</div>

				<div style={{ padding: '10px 14px' }}>
					{row.nama_pemilik && (
						<div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
							<CarOutlined style={{ color: '#1e4d8a', fontSize: 13, width: 16, flexShrink: 0 }} />
							<Text style={{ fontSize: 13, fontWeight: 600, color: '#222' }}>{row.nama_pemilik}</Text>
						</div>
					)}
					<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px' }}>
						<div>
							<div style={{ fontSize: 10, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Pokok SWDKLLJ</div>
							<div style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 700, color: '#1e4d8a' }}>{formatRp(row.pokok_swdkllj)}</div>
						</div>
						<div>
							<div style={{ fontSize: 10, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Pokok SAMSAT</div>
							<div style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 700, color: '#1e4d8a' }}>{formatRp(row.pokok_samsat)}</div>
						</div>
						{(row.denda_swdkllj > 0 || row.denda_samsat > 0) && (
							<>
								<div>
									<div style={{ fontSize: 10, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Denda SWDKLLJ</div>
									<div style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 700, color: '#cf1322' }}>{formatRp(row.denda_swdkllj)}</div>
								</div>
								<div>
									<div style={{ fontSize: 10, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Denda SAMSAT</div>
									<div style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 700, color: '#cf1322' }}>{formatRp(row.denda_samsat)}</div>
								</div>
							</>
						)}
					</div>
					{row.created_at && (
						<div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8, paddingTop: 7, borderTop: '1px dashed #eee' }}>
							<CalendarOutlined style={{ color: '#aaa', fontSize: 11 }} />
							<Text style={{ fontSize: 11, color: '#888' }}>{moment(row.created_at).format('DD-MM-YYYY HH:mm:ss')}</Text>
						</div>
					)}
				</div>

				<div style={{ padding: '8px 14px', background: '#f9fbff', borderTop: '1px solid #edf2f9', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
					{row.is_deleted === true && (
						<Tooltip title="Kirim Ulang">
							<Button size="small" shape="circle" style={{ background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }} onClick={() => this.doRequest(row.id, 'resend')}><SendOutlined /></Button>
						</Tooltip>
					)}
					<Tooltip title="Monitor">
						<Button size="small" shape="circle" type="primary" ghost onClick={() => this.doRequest(row.id, 'monitor')}><EyeOutlined /></Button>
					</Tooltip>
					<Tooltip title="Hapus">
						<Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}><CloseSquareOutlined /></Button>
					</Tooltip>
				</div>
			</Card>
		);
	}

	render() {
		const { errMsg, errTitle, loadingData, loadingExport, dataSource, pagination, isMobile, searchText, filterTanggal } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.jsr-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 12px; color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.jsr-wrap .ant-table-tbody > tr > td { padding: 10px 14px; vertical-align: middle; }
						.jsr-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.jsr-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.jsr-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.jsr-wrap .ant-form-item-label > label { font-weight: 600; color: #374151; font-size: 12px; }
						.jsr-wrap .ant-picker, .jsr-wrap .ant-input { border-radius: 8px !important; }
					`}</style>
				</Helmet>

				<ErrorAlertModal visible={errMsg !== ''} title={errTitle} error={errMsg} onClose={() => this.setState({ errTitle: '', errMsg: '' })} />
				{this.renderDetailModal()}

				<Card className="jsr-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>

					{/* ── Header ── */}
					<div style={{ padding: '16px 20px', background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<IdcardOutlined style={{ marginRight: 8 }} />{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} record{loadingData && ' · Memuat...'}
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
							<Tooltip title="Refresh">
								<Button icon={<RedoOutlined />} onClick={() => this.getData(pagination.current)} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
							<Tooltip title="Download file splitzing">
								<Button icon={<FileExcelOutlined />} loading={loadingExport} onClick={() => this.postDataWithDownload()} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}>
									{!isMobile && 'Download Splitzing'}
								</Button>
							</Tooltip>
						</div>
					</div>

					{/* ── Filter ── */}
					<div style={{ padding: '14px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
						<Form ref={this.formRef} layout="vertical" onFinish={this.handleFilter}>
							<Row gutter={[12, 0]} align="bottom">
								<Col xs={24} sm={12} md={8} lg={7}>
									<Form.Item label="Rentang Tanggal" style={{ marginBottom: 0 }}>
										<RangePicker
											style={{ width: '100%', borderRadius: 8 }}
											format="DD-MM-YYYY"
											value={filterTanggal}
											onChange={(v) => this.setState({ filterTanggal: v })}
											placeholder={['Dari tanggal', 'Sampai tanggal']}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={12} md={8} lg={7}>
									<Form.Item label="Pencarian" style={{ marginBottom: 0 }}>
										<Input
											placeholder="Nomor polisi, nama pemilik, nomor..."
											prefix={<SearchOutlined style={{ color: '#bbb' }} />}
											allowClear
											style={{ borderRadius: 8 }}
											value={searchText}
											onChange={this.handleSearchChange}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8} lg={10}>
									<Form.Item style={{ marginBottom: 0 }}>
										<div style={{ display: 'flex', gap: 8, justifyContent: isMobile ? 'stretch' : 'flex-end', marginTop: isMobile ? 8 : 0 }}>
											<Button onClick={this.handleReset} style={{ borderRadius: 8, flex: isMobile ? 1 : 'unset' }}>Reset</Button>
											<Button type="primary" icon={<SearchOutlined />} htmlType="submit" loading={loadingData}
												style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', borderRadius: 8, fontWeight: 600, flex: isMobile ? 1 : 'unset' }}>
												Filter
											</Button>
										</div>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</div>

					{/* ── Info bar ── */}
					<div style={{ padding: '8px 20px', borderBottom: '1px solid #f0f0f0', background: '#fafcff' }}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
					</div>

					{/* ── Konten ── */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData
									? <div style={{ textAlign: 'center', padding: 48, color: '#aaa' }}>Memuat data...</div>
									: dataSource.length === 0
										? <div style={{ textAlign: 'center', padding: 48, color: '#aaa' }}>Tidak ada data</div>
										: dataSource.map(row => this.renderMobileCard(row))
								}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current} pageSize={pagination.pageSize} total={pagination.total}
											onChange={(page) => this.getData(page)} showSizeChanger={false} simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
									onChange: (page, pageSize) => {
										this.setState(prev => ({ pagination: { ...prev.pagination, pageSize } }), () => this.getData(page));
									},
								}}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler, ajaxDownloadHandler })(DataJasaraharja);
